// Shared Base-Permissions catalogue + per-solution asset list for the role editor.
// Extracted from editRole.js so the pure serde (roleEditorSerde.js) and its tests
// consume the SAME catalogue the component renders — the round-trip identity tests
// would be meaningless against a hand-copied catalogue that could drift.
//
// The engine keys everything by NAME (never array index), so the display order here
// is safe to change (Base-Permissions module order, item 4).

export const ROLE_ASSETS = [
  "Monitoring",
  "Controlling",
  "Configuration",
  "Alarms",
  "Events",
  "Analytics",
  "Group Management",
  "Tracking",
  "Rules",
  "Video Analytics",
  "Digital Twin",
  "History",
  "Metadata",
  // Scoping columns (taxonomy restructure): Threshold Profiles scopes template
  // view/manage per solution; Scheduled Reports scopes report eligibility. Both are
  // excluded from bulk gestures and row Overall (isScopingAsset).
  "Threshold Profiles",
  "Scheduled Reports",
];

export const ALL_UTILS = [
  {
    name: "Administration",
    tabs: [
      { name: "Device Management", permission: "ALL" },
      { name: "User Management", permission: "ALL" },
      { name: "Role Management", permission: "ALL" },
      { name: "Group Management", permission: "ALL" },
      // Master for the whole Solution Management row (R1): its tabs grey out
      // above this rank and cascade down when it lowers.
      { name: "Solution Management", permission: "ALL" },
      { name: "Brand Management", permission: "ALL" },
    ],
    overall: "ALL",
  },
  {
    // The first layer over the per-solution feature assets (R5): a per-solution
    // grant can never exceed its feature master here.
    name: "Solution Features",
    tabs: [
      { name: "Digital Twin", permission: "ALL" },
      { name: "Monitoring", permission: "ALL" },
      { name: "Controlling", permission: "ALL" },
      { name: "Configuration", permission: "ALL" },
      { name: "Events", permission: "ALL" },
      { name: "Tracking", permission: "ALL" },
      { name: "Rules", permission: "ALL" },
      { name: "Alarms", permission: "ALL" },
      { name: "Scheduled Reports", permission: "ALL" },
      { name: "Threshold Profiles", permission: "ALL" },
      { name: "Analytics", permission: "ALL" },
      { name: "Metadata", permission: "ALL" },
      { name: "Video Analytics", permission: "ALL" },
      { name: "History", permission: "ALL" },
    ],
    overall: "ALL",
  },
  {
    name: "Analytics",
    tabs: [
      { name: "Self-Service", permission: "ALL" },
      { name: "Trend Forecasting", permission: "ALL" },
      { name: "Advanced", permission: "ALL" },
      { name: "Comparative", permission: "ALL" },
    ],
    overall: "ALL",
  },
  {
    name: "Solution Management",
    tabs: [
      // Atomic creation (R2): granting Solution Creation mirrors onto the
      // Solution Edit page and every Solution Edit Part.
      { name: "Solution Creation", permission: "ALL" },
      { name: "Solution Edit", permission: "ALL" },
      // R3: requires the Rules / Alarms / Controlling features at >= its rank.
      { name: "Threshold Management", permission: "ALL" },
    ],
    overall: "ALL",
  },
  {
    // The editing parts: what this role may edit in the solution editor, on
    // every solution the role holds. Parts sit under the Solution Edit page
    // rank (R7).
    name: "Solution Edit",
    tabs: [
      { name: "Key Info", permission: "ALL" },
      { name: "Asset", permission: "ALL" },
      { name: "Monitoring", permission: "ALL" },
      { name: "Value Insights", permission: "ALL" },
      { name: "Controlling", permission: "ALL" },
      { name: "Configurations", permission: "ALL" },
      { name: "Layout", permission: "ALL" },
    ],
    overall: "ALL",
  },
];
